module.exports = __webpack_public_path__ + "img/coppercola_hair.77ff1a42.jpg";